import React from 'react'
import HistoryFileUpload from './HistoryFileUpload'
import { isArray } from 'lodash'
import { EMAIL_CATEGORIES } from 'utils/constant'

const HistoryTextBox = ({ title, html, type, showMore = false }: any) => {
    const formatDate = (dateStr: any) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const headerStyle: any = {
        padding: '0.75rem 1.5rem',
        textAlign: 'left',
        fontSize: '0.75rem',
        fontWeight: '500',
        color: '#6B7280',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    };

    const cellStyle: any = {
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        whiteSpace: 'nowrap',
    };

    const mainTableStyle: any = {
        overflowX: 'auto',
        overflowY: 'auto',
        border: '1px solid',
        borderStyle: 'solid',

    };

    const tableStyle: any = {
        minWidth: '100%',
        borderCollapse: 'collapse',
        borderBottom: '1px solid #E5E7EB'
    };

    const bodyStyle: any = {
        backgroundColor: '#FFFFFF',
        borderCollapse: 'collapse',
        borderBottom: '1px solid #E5E7EB'
    };

    return (
        <>
            <div className="border border-[#E6E6E6] rounded-lg p-2 shadow-customShadow10 mb-3 bg-[#fff] ml-14">
                <div className="border border-[#EAECF0] rounded-lg px-3 py-3">
                    <h5 className="text-sm font-interMedium text-[#0A090B] pb-1.5">{title}</h5>
                    {
                        // type != 'isRFP' && type != 'isRichTextContent' &&
                        type != 'isRFP' && !isArray(html) &&
                        <div
                            className={`text-sm font-interMedium text-[#4F4D55] no-css ${showMore ? '' : 'line-clamp-3'}`}
                            dangerouslySetInnerHTML={{ __html: html }}
                        >
                        </div>
                    }
                    {
                        (type == 'isRFP'
                            || type == 'isRichTextContent'
                            || type == 'isEmailContent'
                            || type == EMAIL_CATEGORIES.ATTENDEE_INVITATION
                            || type == EMAIL_CATEGORIES.VENDOR_QUOTE)
                        && isArray(html) && html?.length > 0 &&
                        <div
                            className={`text-sm font-interMedium text-[#4F4D55] no-css ${showMore ? '' : 'line-clamp-3'}`}
                        >
                            <>
                                {
                                    html.map((fd: any, index: number) => (
                                        <React.Fragment key={index}>
                                            <div>
                                                {
                                                    fd?.showLabel &&
                                                    <label>
                                                        <strong>{fd?.title}</strong>
                                                    </label>
                                                }
                                                {
                                                    (fd.type == 'text' || fd.type == 'number') &&
                                                    <>
                                                        {
                                                            fd.title != 'Social Links' &&
                                                            <div
                                                                suppressContentEditableWarning={true}
                                                                className={`pr-14 no-css mb-3`}
                                                                dangerouslySetInnerHTML={{ __html: fd?.content }}
                                                            >
                                                            </div>
                                                        }
                                                        {
                                                            fd.title == 'Social Links' &&

                                                            fd?.content?.length > 0 && fd.content.map((con: any, index: number) => (
                                                                <React.Fragment key={index}>
                                                                    <label>
                                                                        <strong>{con?.title}</strong>:
                                                                        <span className='ml-1.5'>{con?.value}</span>
                                                                    </label>
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </>
                                                }
                                                {
                                                    (fd.type == 'table' && fd.hidden) &&
                                                    <>
                                                        {
                                                            fd?.content && fd?.content?.length > 0 &&
                                                            <div style={mainTableStyle}>
                                                                <table style={tableStyle}>
                                                                    <thead style={{ backgroundColor: '#F9FAFB' }}>
                                                                        <tr>
                                                                            {
                                                                                Object.keys(fd.content[0]).map((key: any, keyIndex: number) => (
                                                                                    <th
                                                                                        key={keyIndex}
                                                                                        scope="col"
                                                                                        style={headerStyle}
                                                                                    >
                                                                                        {key}
                                                                                    </th>
                                                                                ))
                                                                            }
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody style={bodyStyle}>
                                                                        {fd.content.map((value: any, vIndex: any) => (
                                                                            <tr key={vIndex}>
                                                                                <td style={cellStyle}>{typeof value.date === 'string' && value.date.includes('T') ? formatDate(value.date) : value.date}</td>
                                                                                <td style={cellStyle}>{value.location}</td>
                                                                                <td style={cellStyle}>{value.startTime}</td>
                                                                                <td style={cellStyle}>{value.endTime}</td>
                                                                                <td style={cellStyle}>{value.eventName}</td>
                                                                                <td style={cellStyle}>{value.description}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {
                                                    fd.type == 'image' && fd.name == 'RfpInnerLogo' && fd?.content?.imageUrl &&
                                                    <HistoryFileUpload
                                                        fileName={fd?.content?.filename}
                                                        fileSize={null}
                                                        contentType={'isRFP'}
                                                    />
                                                }
                                                {
                                                    fd.type == 'multi' && fd?.content?.image?.imageUrl &&
                                                    <HistoryFileUpload
                                                        fileName={fd?.content?.image?.filename}
                                                        fileSize={null}
                                                        contentType={'isRFP'}
                                                    />
                                                }
                                                <br />
                                            </div>
                                        </React.Fragment>
                                    ))
                                }
                            </>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default HistoryTextBox